export default "__VITE_ASSET__5daea283__"